// Re-export components wrapped with required providers so consuming apps get
// context-enabled components by default.
import { wrapWithProviders } from "./providers/Providers";

import { GanttChart as RawGanttChart } from "./components/gantt-chart";
import { TreeView as RawTreeView } from "./components/tree-view";
import { JsonViewer as RawJsonViewer } from "./components/json-viewer";
import { NarrativeGraph as RawNarrativeGraph } from "./components/narrative-graph";

// Exports
export const GanttChart = wrapWithProviders(
  RawGanttChart
) as React.ComponentType<any>;

export const TreeView = wrapWithProviders(
  RawTreeView
) as React.ComponentType<any>;

export const JsonViewer = wrapWithProviders(
  RawJsonViewer
) as React.ComponentType<any>;

export const NarrativeGraph = wrapWithProviders(
  RawNarrativeGraph
) as React.ComponentType<any>;
// Optional: export raw components in case advanced consumers want to opt-out.
// export * from "./components/button";
// export * from "./components/gantt-chart";
